import { render, staticRenderFns } from "./RedemptionOfOrnament.vue?vue&type=template&id=90085098&"
import script from "./RedemptionOfOrnament.vue?vue&type=script&lang=js&"
export * from "./RedemptionOfOrnament.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports